import { render, staticRenderFns } from "./talents.vue?vue&type=template&id=f24b657a&scoped=true&"
import script from "./talents.vue?vue&type=script&lang=js&"
export * from "./talents.vue?vue&type=script&lang=js&"
import style0 from "./talents.vue?vue&type=style&index=0&id=f24b657a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24b657a",
  null
  
)

export default component.exports